import { Backdrop, Box, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAPI } from "../../../apiContext";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const ForUser = () => {
	const { databyEmail, token } = useAPI();
	const [loading, setLoading] = useState(false);
	const [allSubmits, setAllSubmits] = useState();
	useEffect(() => {
		const fetchData = async () => {
			try {
				const BeforeInstallForUsers = await axios.get(
					`${process.env.REACT_APP_API_PATH}/BeforeInstallForUsers/${databyEmail?.url}`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					},
				);
				setAllSubmits(
					BeforeInstallForUsers?.data?.[0]?.submits?.reverse() || [],
				);
			} catch (error) {
				if (error.response.status) {
					Swal.fire({
						icon: "error",
						title: "Oops...",
						text: error.response.data,
					});
				} else {
					console.log(error);
				}
			}
		};

		if (token) {
			fetchData();
		}
	}, [loading, token, databyEmail]);

	const handleDelete = (id) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setLoading(true);
				try {
					await axios
						.delete(
							`${process.env.REACT_APP_API_PATH}/deleteBeforeInstallSingle/${id}/${databyEmail?.url}`,
							{
								headers: {
									Authorization: `Bearer ${token}`,
								},
							},
						)
						.then(function (response) {
							Swal.fire("Deleted!", "That submit has been deleted.", "success");
							setLoading(false);
						});
				} catch (error) {
					if (error.response.status) {
						Swal.fire({
							icon: "error",
							title: "Oops...",
							text: error.response.data,
						});
					} else {
						console.log(error);
					}
				}
			}
		});
	};
	const columns = [
		{
			field: "userName",
			headerName: "User Name",
			minWidth: 200,
			flex: 1,
		},
		{
			field: "email",
			headerName: "Email",
			minWidth: 230,
			flex: 1,
		},
		{
			field: "submitTime",
			headerName: "Submit Time",
			minWidth: 200,
			flex: 1,
		},
		{
			field: "from",
			headerName: "From",
			minWidth: 310,
			filterable: false,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						{params.row?.city}, {params.row?.country}{" "}
						<img src={params.row?.countryFlag} alt={params.row?.country} />
					</>
				);
			},
		},
		{
			field: "Action",
			headerName: "Action",
			minWidth: 310,
			filterable: false,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						<Button
							className='button border'
							onClick={() => handleDelete(params.row?.infoId)}
							sx={{
								fontWeight: "bold",
								border: "2px solid",
								backgroundColor: "transparent",
								borderRadius: "25px",
								m: 0.5,
							}}
							variant='contained'>
							<DeleteIcon />
						</Button>
					</>
				);
			},
		},
	];
	return (
		<Box>
			{allSubmits && (
				<Box
					sx={{
						width: "100%",
						height: { md: "80vh", xs: "90vh" },
						"& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
							border: "1px solid",
							fontSize: "0.75rem",
							padding: "0px 5px",
							textTransform: "capitalize",
						},
						"& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root": {
							fontSize: "1rem",
						},
					}}>
					<DataGrid
						componentsProps={{
							panel: {
								sx: {
									"& .MuiDataGrid-panelContent": {
										maxWidth: "100vw !important",
									},
								},
							},
						}}
						rows={allSubmits || []}
						getRowId={(row) => row?.infoId}
						columns={columns}
						components={{
							Toolbar: GridToolbar,
						}}
						disableSelectionOnClick
					/>
				</Box>
			)}

			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={!allSubmits || loading}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Box>
	);
};

export default ForUser;
